<template>
  <div class="simulations-index">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

  mounted() {
    if (this.$route.name == "simulations-index") {
      this.$router.push({
        name: "funding-simulation-home"
      })
    }
  }
}
</script>

<style></style>